export enum AMPLITUDE_EVENTS {
  // Sign up Events
  CLICKED_SIGNUP_BTN = "Clicked Sign up button",
  BRASS_USER_SIGNUP = "Viewed Signup through Brass link",
  SCALEIN_USER_SIGNUP = "Viewed Signup through ScaleIn link",
  STERLING_USER_SIGNUP = "Viewed Signup through Sterling link",
  PRINTIVO_USER_SIGNUP = "Viewed Signup through Printivo link",
  SIDE_BRIEF_USER_SIGNUP = "Viewed Signup through Sidebrief link",
  SIGN_UP_FLOW = "sign_up_flow",
  PAYMENT_NOT_RETURNED = "number_purchase_payment_pending",

  // Sign in events
  CLICKED_SIGNIN_BTN = "Clicked Signin",
  LOGIN = "User Signedin",
  WINBACK_CAMPAIGN_SIGNIN = "Winback Campaign Signin",

  // Call Queue
  START_CALL_QUEUE = "Started Call Queue",
  PAUSE_CALL_QUEUE = "Paused Call Queue",
  RESUME_CALL_QUEUE = "Resumed Call Queue",

  // Recommended Plan Events
  VIEWED_RECOMMENDED_FORM = "Viewed Recommendation Form",
  VIEWED_RECOMMENDED_PLAN = "Viewed Recommended Plan",

  // SELECTED_SOLO_PLAN = "Selected Plan: Solo ",
  SELECTED_STANDARD_PLAN = "Selected Plan: Standard ",
  SELECTED_GROWTH_PLAN = "Selected Plan: Growth ",
  SELECTED_INTERNATIONAL_PLAN = "Selected Plan: International ",

  // SELECTED_SOLO_QUARTERLY_PLAN = "Selected Plan: Solo Quaterly",
  SELECTED_STANDARD_QUARTERLY_PLAN = "Selected Plan: Standard Quaterly",
  SELECTED_GROWTH_QUARTERLY_PLAN = "Selected Plan: Growth Quaterly",
  SELECTED_INTERNATIONAL_QUARTERLY_PLAN = "Selected Plan: International Quaterly",

  // SELECTED_SOLO_ANNUAL_PLAN = "Selected Plan: Solo Anual",
  SELECTED_STANDARD_ANNUAL_PLAN = "Selected Plan: Standard Anual",
  SELECTED_GROWTH_ANNUAL_PLAN = "Selected Plan: Growth Anual",
  SELECTED_INTERNATIONAL_ANNUAL_PLAN = "Selected Plan: International Anual",

  // Number Setup
  VIEWED_NUMBER_SETUP = "Viewed number setup",
  CLICKED_PURCHASE_ADDITIONAL_NUMBER = "Clicked purchase additional number",
  COMPLETED_SETUP_FLOW = "Completed Setup Flow", // donne
  VIEW_AVAILABLE_NUMBER = "View Available numbers",
  SELECT_NUMBER = "Select number",
  NUMBER_SELECTED = "number_selected",

  // Onboarding events
  CLICKED_TEST_CALL = "Clicked Test call",
  TEST_CALL_SUCCESSFUL = "Test call successful",
  TEST_CALL_FAILED = "Test call failed",
  CLICKED_INVITE_TEAM_MEMBER = "Clicked Invite Team Member",
  CLICKED_VERIFY_ACCOUNT = "Clicked Verify Account",
  COMPLETED_ACCOUNT_VERIFICATION = "Completed account verification",
  CLICKED_INCOMING_CALL_FLOW = "Clicked Incoming call flow",
  CLICKED_OUT_OF_OFFICE_FLOW = "Clicked Out-of-office flow",
  ONBOARDING_PAGE_VIEWED = "onboarding_page_viewed",
  MAKE_FIRST_CALL_BUTTON_CLICKED = "make_first_call_button_clicked",
  FIRST_CALL_RATING_VIEWED = "first_call_rating_viewed",
  FIRST_CALL_RATING_COMPLETED = "first_call_rating_completed",

  // Call
  OPEN_DIALLER = "Open dialler",
  CLOSED_DIALLER = "Close dialler",
  SIP_CONNECTED = "Sip connected",
  SIP_DISCONNECTED = "Sip disconnected",
  SIP_CONNECTION_ERR = "Sip connection error",
  CALL_TRANSFERRED = "call transfered",
  CALL_MUTED = "call muted",
  CALL_HELD = "call on hold",

  // Billing
  UPGRADED_SUBSCRIPTION = "Click Upgrade Subscription",
  CANCELLED_SUBSCRIPTION = "Click Cancel Subscription",

  // Integrations
  CLICK_CONNECT_TO_ZOHO_CRM = "Click connect to Zohocrm",
  CLICK_CONNECT_TO_HUBSPOT_CRM = "Click connect to Hubspot",
  CLICK_CONNECT_TO_FRESHDESK = "Click connect to Freshdesk",
  CLICK_CONNECT_TO_GOOGLE_CHROME_EXTENSION = "Click connect to Google Chrome Extension",
  CLICK_CONNECT_TO_PIPE_DRIVE = "Click connect to Pipe Drive",
  CLICK_CONNECT_TO_ZOHO_PHONE_BRIDGE = "Click connect to Zoho Phone Bridge",
  CLICK_CONNECT_TO_INTERCOM = "Click connect to Intercom",
  CLICK_CONNECT_TO_PRESSONE_WIDGET = "Click connect Pressone Widget",
  CLICK_CONNECT_TO_ZAPIER = "Click connect to Zapier",

  // Personalization
  CREATED_TAG = "tag_created",
  CREATE_TAG_ATTEMPTED = "tag_create_attempted",
  CREATED_CALL_SCRIPT = "created_call_script",
  CALL_SCRIPT_UPDATE_ATTEMPTED = "call_script_update_attempted",
  CALL_SCRIPT_OPEN_ATTEMPTED = "call_script_open_attempted",
  CALL_SCRIPT_OPEN_SUCCESSFUL = "call_script_open_successful",
  WGH_REFERALL_SIGNUP = "New WGH referral signup",
  PRESSONE_WEBSITE_SIGNUP = "New PressOneWebsite signup",

  // Feedbck
  NEW_EXPERIENCE_FEEBACK_SUBMITTED = "New experience feedback submitted",
  HEARD_ABOUT_US = "Where did you hear about us",

  // Share provisioned number
  SHARE_NUMBER = "share-number",
  SHARE_ADDRESS = "share-address",
  CLICK_REACTIVATE_SUBSCRIPTION = "Click reactivate subscription",
  RENEW_SUBSCRIPTION = "Click renew subscription",
  FIRST_CALL_RATINGS = "First Call Rating",
  VIEWED_GO_GLOBAL_PRICING = "Viewed Go-global pricing",
  CLICKED_BUY_NUMBER = "Clicked buy number",
  VIEWED_ORDER_REVIEW = "Viewed order review",
  CLICKED_MAKE_PAYMENT = "Clicked make payment",

  // Call recording events
  CALL_RECORDING_SHARE = "call recording share",
  CALL_RECORD_SHARE = "call records share",
  CALL_NOTE_SAVED = "call note added",
  CALL_NOTE_SAVE_ATTEMPTED = "call_note_save_attempted",
  CALL_RECORD_DOWNLOAD = "call record download",
  CALL_RECORD_PLAYED = "call recording played",
  PLAYING_CALL_RECORDING = "Play recording",
  OPEN_CALL_DETAILS = "open call details",
  OPEN_CALL_RECORD = "Open call records",
  CLICK_EXPORT_CSV = "click export csv",
  EXPORTED_CSV = "exported csv",
  FILTER_CALL_DURATION = "filter by call duration",

  // Hangup events
  HANGUP = "hangup", // (after call is picked)
  HANGUP_REJECTED = "hangup_rejected", // (if it's inbound and they chose not to pick it)
  HANGUP_BEFORE_SESSION_STARTS = "hangup_before_session_starts",

  // Card tracking
  CLICKED_UPDATE_CARD = "click update card",

  // Network
  CLICKED_NETWORK_BAR = "click network bar",
  VIEW_NETWORK_DETAILS = "view network details",

  // IVR
  CREATE_A_MENU_OPTION = "Create menu option",

  // Dashboard engagement
  RETURN_TO_DASHBOARD = "return_to_dashboard",
  SAVE_IVR = "Save ivr",

  // Addons
  CLICKED_SALES_CAMPAIGN_ADDON_SUBSCRIBE_BUTTON = "Clicked Sales Campaign Addon Subscribe Button",
  SUBSCRIBED_SALES_CAMPAIGN_ADDON = "Subscribed Sales Campaign Addon",
  CLICKED_SALES_CAMPAIGN_ADDON_CREATE_BUTTON = "Clicked Sales Campaign Addon Create Button",
  SAVED_CREATED_CAMPAIGN = "Saved Created Campaign",
  VIEWED_SALES_CAMPAIGN_ADDON_CAMPAIGN_REPORT = "Viewed Sales Campaign Addon Campaign Report",
  EXPORT_SALES_CAMPAIGN_ADDON_CAMPAIGN_REPORT = "Export Sales Campaign Addon Campaign Report",

  // Conversations
  CLICKED_CREATE_CONVERSATION = "Click create a conversation",
  CLICKED_EDIT_CONVERSATION_TITLE = "Click edit conversation title",
  CLICKED_INVITE_TEAM_MEMBER_TO_CONVERSATION = "Click invite a team member",
  CLICKED_INVITE_CUSTOMER = "Click invite a customer",
  CLICKED_CLOSE_CONVERSATION = "Click close a conversation",
  CLICKED_LEAVE_CONVERSATION = "Click leave a conversation",
  CLICKED_SAVE_CUSTOMER_DETAILS = "Click save customer details",
  CLICKED_UPLOAD_FILE_TO_CONVERSATION = "Click upload a file to a conversation",
  CLICKED_ADD_NOTE_TO_CONVERSATION = "Click add a call note to a conversation",
  CLICKED_MERGE_CONVERSATION = "Click to merge conversations",

  // Open signup page (fe)
  OPENED_SIGNUP_PAGE = "Opened Signup Page",
  SELECTED_OTP_OPTION = "Selected OTP Option",
  OPENED_FORGOT_PASSWORD = "Opened Forgot Password",
  OPENED_RESET_PASSWORD = "Opened Reset Password",

  // New amplitude events
  VERIFICATION_BUTTON_CLICKED = "verification_button_clicked",
  VERIFICATION_DOCUMENTS_SUBMITTED = "verification_documents_submitted",
  MANUAL_VERIFICATION_CLICKED = "manual_verification_clicked",
  ADD_TEAM_MEMBER_CLICKED = "add_team_member_clicked",
  GREETINGS_SETUP_CLICKED = "greetings_setup_clicked",

  DOWNLOAD_MOBILE_APP_VIEWED = "download_mobile_app_viewed",
  DOWNLOAD_MOBILE_APP_CLICKED = "download_mobile_app_clicked",

  CUSTOMER_ONBOARDING_FEEDBACK_SURVEY_VIEWED = "customer_onboarding_feedback_survey_viewed",
  CUSTOMER_ONBOARDING_FEEDBACK_SURVEY_COMPLETED = "customer_onboarding_feedback_survey_completed",

  INVOICE_VIEWED = "invoice_page_viewed",
  PAYMENT_ATTEMPTED = "payment_attempted",
  PAYMENT_ATTEMPTED_FAILED = "payment_attempted_failed",
  INVOICE_PAYMENT_LINK_SENT = "invoice_payment_link_sent",

  EXIT_INTENT_BUSINESS_NEED = "exit_intent_business_need",
  TARGET_BUYDATE_SELECTED = "target_buydate_selected",
  EXIT_INTENT_POPUP_RESPONSE = "exit_intent_popup_response",

  // New recent event set
  // to be done with the new flow for verification
  VERIFICATION_SUCCESSFUL = "verification_success",
  TEAM_MEMBER_INVITED = "team_member_invited",
  GREETINGS_CHANGED = "greetings_changed",
  REPORT_CLICKED = "report_clicked",
  SUMMARY_REPORT_CLICKED = "summary_report_clicked",
  AUDIT_REPORT_CLICKED = "audit_report_clicked",
  LEADERBOARD_CLICKED = "leaderboard_clicked",
  EXPORT_SUMMARY_REPORT_CLICKED = "export_summary_report_clicked",
  EXPORT_SUMMARY_REPORT_COMPLETED = "export_summary_report_completed",
  EXPORT_TEAM_REPORT_CLICKED = "export_team_report_clicked",
  EXPORT_TEAM_REPORT_COMPLETED = "export_team_report_completed",

  EXPORT_LEADERBOARD_CLICKED = "export_leaderboard_clicked",
  EXPORT_LEADERBOARD_COMPLETED = "export_leaderboard_completed",
  CALL_REPORT_DOWNLOADED = "call_report_downloaded",

  // Typeform events
  WATCHED_EMBEDDED_VIDEO = "watched embedded video",
  FILLED_TYPE_FORM = "filled type form",

  // Go Global
  INTERNATIONAL_PAYMENT_ATTEMPTED = "international_payment_attempted",

  // Music on hold
  UPLOADED_MUSIC_ON_HOLD = "uploaded_music_on_hold",

  // Paystack payment
  PAYSTACK_PAYMENT_ATTEMPTED = "paystack_payment_attempted",
  PAYSTACK_PAYMENT_SUCCESS = "paystack_payment_success",
  PAYSTACK_PAYMENT_FAILED = "paystack_payment_failed",
  PAYSTACK_PAYMENT_CANCELLED = "paystack_payment_cancelled",

  // Page view
  PAGE_VIEW = "page_view",

  // New customer events
  CONGRATULATIONS_PAGE_SEEN = "congratulations_page_seen",
  LISTENED_TO_DEFAULT_GREETING = "listened_to_default_greeting",
  TYPEFORM_SETUP_STARTED = "typeform_setup_started",
  TYPEFORM_SETUP_SUBMITTED = "typeform_setup_submitted",
  NUMBER_ACTIVATION_PROGRESS_SEEN = "number_activation_progress_seen",

  CONVERSATION_START_ATTEMPTED = "conversation_start_attempted",
  CONVERSATION_START_SUCCESSFUL = "conversation_start_successful",
  AIRTIME_TOPUP_ATTEMPTED = "top_up_airtime_attempted",
  AIRTIME_TOPUP_SUCCESSFUL = "top_up_airtime_successful",

  // New user journey events
  PROCEED_TO_VERIFY_NIN_CLICKED = "proceed_to_verify_nin_clicked",
  SEEN_LINE_ACTIVATED_PAGE = "seen_line_activated_page",
  CONNECTED_DEVICES_PAGE_SEEN = "connected_devices_page_seen",
  LISTEN_TO_RECORDING_ATTEMPTED = "listen_to_recording_attempted",
  CALL_RECORDING_PLAYED = "call_recording_played",
  CONTACT_UPLOAD_ATTEMPTED = "contact_upload_attempted",
  CONTACT_UPLOAD_SUCCESSFUL = "contact_upload_successful",
  CONTACT_VIEW_ATTEMPTED = "contact_view_attempted",
  CONTACT_VIEW_SUCCESSFUL = "contact_view_successful",
  CONTACT_EDIT_ATTEMPTED = "contact_edit_attempted",
  CONTACT_EDIT_SUCCESSFUL = "contact_edit_successful",
  CALL_QUEUE_CREATE_ATTEMPTED = "call_queue_create_attempted",
  CALL_QUEUE_CREATE_SUCCESSFUL = "call_queue_create_successful",
  CALL_QUEUE_COMPLETE_ATTEMPTED = "call_queue_complete_attempted",
  RENEWAL_FROM_DASHBOARD_ATTEMPTED = "renewal_from_dashboard_attempted",

  // Connected Devices Events
  CONNECTED_DEVICES_NUDGE_CLICKED = "connected_devices_nudge_clicked",
  CONNECTED_DEVICES_NUDGE_SENT = "connected_devices_nudge_sent",
  CONNECTED_DEVICES_NUDGE_FAILED = "connected_devices_nudge_failed",
  CONNECTED_DEVICES_VIEW_HISTORY_CLICKED = "connected_devices_view_history_clicked",
  CONNECTED_DEVICES_VIEW_REPORT_CLICKED = "connected_devices_view_report_clicked",
  CONNECTED_DEVICES_CALL_CLICKED = "connected_devices_call_clicked",

  // Nps survey events
  NPS_FEEDBACK_SUBMITTED = "nps_feedback_submitted",
  NPS_PROMPT_FAILED = "nps_prompt_failed",

  // New accept invite events
  INVITE_DEFAULT_LINK_COPIED = "invite_default_link_copied",
  EXTRA_USER_PAYMENT_CLICKED = "extra_user_payment_clicked",
  EXTRA_USER_PAYMENT_INITIATED = "extra_user_payment_initiated",
  EXTRA_USER_PAYMENT_FAILED = "extra_user_payment_failed",

  // New Purchase address events
  ADDRESS_SIGN_UP_FORM_VIEWED = "address_sign_up_form_viewed",
  ADDRESS_SIGN_UP_STEP_COMPLETED = "address_sign_up_step_completed",
  ADDRESS_LOCATION_STEP_VIEWED = "address_location_step_viewed",
  ADDRESS_LOCATION_STEP_COMPLETED = "address_location_step_completed",
  ADDRESS_INVOICE_STEP_VIEWED = "address_invoice_step_viewed",
  ADDRESS_BILLING_FREQUENCY_CHANGED = "address_billing_frequency_changed",
  ADDRESS_INVOICE_AMOUNT_UPDATED = "address_invoice_amount_updated",
  ADDRESS_INVOICE_STEP_BACK_NAVIGATION = "address_invoice_step_back_navigation",
  ADDRESS_BUY_NOW_CLICKED = "address_buy_now_clicked",
  ADDRESS_PAYMENT_REDIRECT_INITIATED = "address_payment_redirect_initiated",
  ADDRESS_PAYMENT_SUCCESS = "address_payment_success",
  ADDRESS_PAYMENT_FAILED = "address_payment_failed",
  ADDRESS_PAYMENT_ABANDONED = "address_payment_abandoned",
  ADDRESS_CONGRATULATIONS_PAGE_VIEWED = "address_congratulations_page_viewed",
  ADDRESS_ADDRESS_COPIED = "address_address_copied",
  ADDRESS_SHARE_CLICKED = "address_share_clicked",
}
